import { PaginationModel } from '@/core/types/models/pagination.model'
import { PostModel } from '@/features/blog/types/models/post.model'
import { create } from 'zustand'

type PostsStore = {
  posts: PostModel[]
  pagination: PaginationModel | null
  loading: boolean
  setLoading: (loading: boolean) => void
  setPosts: (posts: PostModel[], pagination: PaginationModel) => void
  appendPosts: (posts: PostModel[], pagination: PaginationModel) => void
}

export const usePostsStore = create<PostsStore>(set => ({
  posts: [],
  pagination: null,
  loading: false,
  setLoading: loading => set({ loading }),
  setPosts: (posts, pagination) => set({ posts, pagination }),
  appendPosts: (newPosts, newPagination) =>
    set(state => ({
      posts: [...state.posts, ...newPosts],
      pagination: {
        ...newPagination,
        currentPage: newPagination.currentPage,
      },
    })),
}))
